import React from "react";
import { useState, useEffect, useRef } from "react";
import { MapContainer, TileLayer } from "react-leaflet";

import ConsolClusterIcon from "./ConsolClusterIcon.js";
import ConsolLegend from "./ConsolLegend.js";
import ConsolMapMessage from "./ConsolMapMessage.js";
import ConsolMarker from "./ConsolMarker.js";
import ConsolGeocoder from "./ConsolGeocoder.js";

export default function ConsolMap({data, infoMessage, mapType, options}) {

  const [map, setMap] = useState(null);
  
  var url = options.baseLayers.url + "&apiKey=" + options.baseLayers.layerOptions.apiKey;

  const dataRef = useRef(data);
  
  options.mapType = mapType; // boots supplierSelection order
  const optionsRef = useRef(options);

  // Supplier selection requires us to get the depot markers
  const generateSupplierDepots = (contractNo) => {
	  
	var contractNoArr = [];

	if($('.supplierSelectionCheckbox').length > 0){
		
		var selectedCheckboxes = $('.supplierSelectionCheckbox:checkbox:checked');
		
		for(var i=0; i<selectedCheckboxes.length; i++) {
			var contractNo = $(selectedCheckboxes[i]).attr('contractNo');
			if(contractNo) contractNoArr.push(parseInt(contractNo));
		}
		
	} else if($('.supplierSelectionRadio').length > 0){
		
		if(contractNo) {
			contractNoArr.push(parseInt(contractNo));
		}
	}

	var supplierData = getSelectedSuppliers(options, contractNoArr);
	supplierData.push(data[0]); // the order
	 
    var markerArr = [];
    supplierData.map((item, idx) => (
       markerArr.push(<ConsolMarker key={idx} item={item} idx={idx} mapType={mapType} />)
    ));
    
    return markerArr;
  };

  // If this is not the boots on the ground map then generate the markers
  // We then set these markers into state, so when the markers update (like on supplier selection)
  // we update state and the markers update themselves
  var markerArr = [];
  if(mapType != 'boots'){
	 
	 if(mapType == 'supplierSelection'){
		markerArr = generateSupplierDepots($('#selectedContractNo').val());
	 } else {

	   data.map((item, idx) => (
         markerArr.push(<ConsolMarker key={idx} item={item} idx={idx} mapType={mapType} />)
       ));
       
	 }
  }
  const [markers, setMarkers] = useState(markerArr);

  // Makes the map fit around the markers and sets zoom level, after the map has rendered
  useEffect(() => {
    if (map) {
		
      var minAutoZoom = optionsRef.current.defaults.minAutoZoom;
      var maxAutoZoom = optionsRef.current.defaults.maxAutoZoom;
		
      var markerArray = [];

      for (var i = 0; i < dataRef.current.length; i++) {
        var item = dataRef.current[i];
        markerArray.push(L.marker([item.lat, item.lng]));
      }

      if(mapType == 'supplierSelection') {
		
		for (var i = 0; i < markers.length; i++) {
	        var item = markers[i];
	        markerArray.push(L.marker([item.props.item.lat, item.props.item.lng]));
	      }
	  }

      map.fitBounds(L.featureGroup(markerArray).getBounds().pad(0.2), {
        minZoom: minAutoZoom,
        maxZoom: maxAutoZoom,
      });

      if (markerArray.length > 1) {
        var targetZoom = map.getZoom();
        if (targetZoom < minAutoZoom) {
          map.setZoom(minAutoZoom);
        } else if (targetZoom > maxAutoZoom) {
          map.setZoom(maxAutoZoom);
        }
      } else {
		  
		if(optionsRef.current.mapType == 'boots') {
		    // Boots zoom to 11 
	        map.setZoom(11);
	    } else {
	        // otherwise for singular orders, zoom to 14
			map.setZoom(14);
		}
      }
      
    }
  }, [map]);

  // Sets up a marker listener for supplier selection radio buttons and supplier selection checkboxes
  // so that when these are clicked, then the supplier selection map re-renders
  const listener = (e) => {
    
    // this is for radio buttons
    var contractNo = $(e.currentTarget).attr('contractNo');
    
    var markerArr = generateSupplierDepots(contractNo);
  	setMarkers(markerArr);
  };
  
  useEffect(() => {
    $('.supplierSelectionRadio').on('click', listener);
    $('.supplierSelectionCheckbox').on('click', listener);
    $('.supplierSelectionSelectAll').on('click', listener);
  }, []);

  if (mapType == 'boots') {
	  return (
	    <MapContainer
    	  minZoom={options.options.minZoom}
   		  zoom={options.defaults.initialZoom}
	      maxZoom={options.options.maxZoom}
	      className="consol-map"
	      center={[options.defaults.center.lat, options.defaults.center.lng]}
	      scrollWheelZoom={true}
	      ref={setMap}
	    >
	      <TileLayer 
	      	url={url} 
	      	attribution={options.baseLayers.layerOptions.attribution} />
	      <ConsolMapMessage message={infoMessage} map={map} />
	      <ConsolClusterIcon data={data} mapType={mapType}></ConsolClusterIcon>
	      <ConsolLegend map={map} mapType={mapType}></ConsolLegend>
	    </MapContainer>
	  );
  } else {

	return (
	    <MapContainer
	      minZoom={options.options.minZoom}
	      zoom={options.defaults.initialZoom}
	      maxZoom={options.options.maxZoom} 
	      className="consol-map"
	      center={[-37.815207, 144.963937]}
	      scrollWheelZoom={true}
	      ref={setMap}
	    >
	      <TileLayer 
	        url={url} 
	        attribution={options.baseLayers.layerOptions.attribution} />
	      <ConsolMapMessage message={infoMessage} map={map} />

		  {markers}
		  
	      <ConsolLegend map={map} mapType={mapType}></ConsolLegend>
	    </MapContainer>
	  );
  }
}

  // Gets the selected suppliers from the page
  // If there are collisions of the same supplier, and one of them is the selected supplier, then 
  // the selected supplier marker will be used
  function getSelectedSuppliers(mapOptions, selectedContractArr) {
	  
    const geocoder = new ConsolGeocoder(mapOptions);
	
	var validDepots = {}
	var supplierDepots = $('.supplierDepotJsonData');
	for(var i=0; i < supplierDepots.length; i++){
		
		var supplierJsonData = $(supplierDepots[i]).attr('supplierdepotjson');
		if(!supplierJsonData) continue;
		
		var supplierItems = JSON.parse(supplierJsonData);
		
		for(var j=0; j<supplierItems.length; j++){
			
			var item = supplierItems[j];
			
			// CHeck to see if this is a mappable depot 
			var isMappableDepot = !!item && !!item.address && geocoder.validateLatLngOfAddressModel(item.geocoderAddress);
            
			if(isMappableDepot) {
				item.lat = item.geocoderAddress.gpsLatitude;
				item.lng = item.geocoderAddress.gpsLongitude;
				
				if(selectedContractArr && selectedContractArr.includes(item.contractNo)) {
					item.markerType = 'supplierSelected';
				} else {
					item.markerType = 'supplier';
				}
				
				// does this depot already exist?
				if(validDepots[item.geocoderAddress.gpsLatitude + '/' + item.geocoderAddress.gpsLongitude]){

					var existingItem = validDepots[item.geocoderAddress.gpsLatitude + '/' + item.geocoderAddress.gpsLongitude];

					// the same depot has already been added
	                // update contract # to be multiple

					if(selectedContractArr &&  selectedContractArr.includes(item.contractNo)) {
						existingItem.markerType = 'supplierSelected';
					}
					
					existingItem.contractRefId = mapOptions.messages['address.marker.tooltip.multiple.contracts'];
					validDepots[item.geocoderAddress.gpsLatitude + '/' + item.geocoderAddress.gpsLongitude] = existingItem;
					
				} else {
					validDepots[item.geocoderAddress.gpsLatitude + '/' + item.geocoderAddress.gpsLongitude] = item;
				}
			}
		}
	}
	
	return Object.values(validDepots);
  }